<script setup lang="ts">
import { GiftPayload } from '@/api/modules/basket/types'
import { GiftProduct } from '@/types/api/api-v3/basket'

import BasketGiftsCard from '@/components/Basket/basket-gifts/BasketGiftsCard.vue'

type Props = {
  products: GiftProduct[]
  ruleId: number
  isGiftNeed: boolean | undefined
  selectedGift: GiftPayload | null
}

const emit = defineEmits(['selectGift'])
const props = defineProps<Props>()

const selectGift = (productId: number) =>
  emit('selectGift', {
    rule_id: props?.ruleId,
    product_id: productId,
  })
</script>

<template>
  <div class="gifts-list">
    <basket-gifts-card
      v-for="gift in products"
      :key="gift.title"
      class="gifts-list__card"
      :gift="gift"
      :is-gift-selected="selectedGift?.product_id === gift.product_id"
      :is-gift-need="isGiftNeed"
      @on-select="selectGift(gift.product_id)"
    />
  </div>
</template>

<style lang="scss" scoped>
.gifts-list {
  position: relative;
  display: flex;
  gap: 0 16px;
  justify-content: flex-start;
  padding: 0 20px;
  margin: 0 -20px 16px;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  scroll-snap-type: x mandatory;
  scroll-padding-inline: 20px;

  @include invisible-scroll-bar();

  &__card {
    flex-basis: 144px;
    flex-shrink: 0;
    max-width: 144px;
    scroll-snap-align: start;
    scroll-snap-stop: always;

    @include media('>=desktop-mini') {
      flex-basis: 176px;
      max-width: 176px;
    }
  }
}
</style>
